import { Tooltip } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  hasPlanAccess?: boolean;
  hasRoleAccess?: boolean;
  children: ReactNode;
  tooltip?: string; //  default tooltip when access is allowed
};

export function AccessControlledWrapper({ hasPlanAccess = true, hasRoleAccess = true, children, tooltip }: Props) {
  const canAccess = hasPlanAccess && hasRoleAccess;
  const { t } = useTranslation();
  if (canAccess) {
    return tooltip ? (
      <Tooltip title={tooltip} rootClassName="mobile-hide-tooltip" placement="bottomRight">
        {children}
      </Tooltip>
    ) : (
      <>{children}</>
    );
  }

  //  Priority: Plan > Role
  let tooltipTitle: string | undefined;

  if (!hasPlanAccess) {
    tooltipTitle = t('please_upgrade_here_to_higher_plan_to_access_this_feature');
  } else if (!hasRoleAccess) {
    tooltipTitle = t('this_feature_is_accessible_to_users_with_admin_role');
  }

  return (
    <Tooltip title={tooltipTitle} rootClassName="mobile-hide-tooltip" placement="bottomRight">
      <div className="cursor-not-allowed">{children}</div>
    </Tooltip>
  );
}
